<template>
  <section class="container">
    <Row class="titleM">
      <Col span="3" class="text-center logo-wrapper">
        <div class="logo-container">
          <img class="logo pointer" @click="tabClick('/')" :src="Logo" alt="">
        </div>
      </Col>
      <Col span="14" class="title text-left">
      <div class="wrapper">
        <div class="brand" @click="tabClick('/')">
          <div class="ZN pointer justify-line">
            新疆软件行业协会
          </div>
          <div class="EN pointer justify-line">
            Xinjiang Software Industry Association
          </div>
        </div>
        <div class="qualification">
          <div class="vertical-line"></div>
          <div class="qualification-text">
            <p class="justify-line">自治区级专业技术</p>
            <p class="justify-line">人员继续教育基地</p>
          </div>
        </div>
      </div>
      </Col>
      <Col span="7" class="userM">
      <div class="wrapper flex-row text-center">
        <div class="col-55">
          <div class="avatar flex-row">
            <!--<div class="col-10"></div>-->
            <div class="col-35 text-center">
              <img v-if="$store.state.isLogin && $store.state.user.headImg != null" class="pointer"
                @click="tabClick('/Center')" :src="$store.state.user.headImg" alt />
              <img v-if="$store.state.isLogin && ($store.state.user.headImg == null || $store.state.user.headImg == '')"
                class="pointer" @click="tabClick('/Center')" src="../../assets/head.png" alt />
              <img v-if="!$store.state.isLogin" class="pointer" @click="loginClick" src="../../assets/head.png" alt />
              <!--<div v-if="!$store.state.isLogin" class="preImg"></div>-->
            </div>
            <div class="col-65">
              <div class="text-left overflow">
                <span v-if="$store.state.isLogin" class="pointer" @click="tabClick('/Center')">{{
                  $store.state.user.realName }}</span>
                <span v-else class="else pointer" @click="loginClick">登录</span>
              </div>
              <div class="text-left overflow">
                <span v-if="$store.state.isLogin" class="pointer idCard" @click="tabClick('/Center')">{{
                  showUser($store.state.user.idCard) }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-30 status" v-if="$store.state.isLogin">
          <el-button type="primary" round>{{ $store.state.user.statusName }}</el-button>
        </div>
        <div class="col-15 notice">
          <div class="relate">
            <img class="bell pointer" v-if="noread" src="../../assets/unbell.gif" alt @click="tabClick('/Msg')" />
            <img class="bell pointer" v-else src="../../assets/bell.png" alt @click="tabClick('/Msg')" />
            <!--<div class="alert" v-if="noread" ></div>-->
          </div>
          <div>消息</div>
        </div>
      </div>
      </Col>
    </Row>
    <Row class="Nav" :class="$store.state.fixed ? 'NavFixed' : ''">
      <Col span="2" class="text-center pointer" :class="$store.state.tab == '首页' ? 'active' : ''">
      <div @click="tabClick('/')">首页</div>
      </Col>
      <Col span="2" class="text-center help pointer relative" :class="{ 'active': $store.state.tab == '职称继教' }">
      <!-- 职称继教舍弃下拉框统一入口职称继教初级 -->
      <div @click="tabClickZc(4)">
      <!-- 根据需求暂时弹出未开始报名的提示 -->
      <!-- <div @click="openPrompt"> -->
        职称继教
        <!-- <Icon type="ios-arrow-down" />
          <div class="ivu-select-dropdown dropdown">
            <ul class="ivu-menu-drop-list">
              <li class="ivu-menu-item-group"
                v-for="courseItem in courseNameContent.filter(c => c.subjectName.includes('职称继教'))"
                :key="courseItem.subjectCode">
                <ul>
                  <li v-if="courseItem.subjectName.includes('初级')" class="ivu-menu-item"
                    @click="tabClickZc(courseItem.subjectCode)">
                    初级
                  </li>
                  <li v-if="courseItem.subjectName.includes('中级')" class="ivu-menu-item"
                    @click="tabClickZc(courseItem.subjectCode)">
                    中级
                  </li>
                  <li v-if="courseItem.subjectName.includes('高级')" class="ivu-menu-item"
                    @click="tabClickZc(courseItem.subjectCode)">
                    副高级
                  </li>
                </ul>
              </li>
            </ul>
          </div> -->
      </div>
      </Col>
      <!-- 根据需求隐藏 -->
      <!-- <Col span="2" class="text-center pointer" :class="$store.state.tab == '学习' ? 'active' : ''">
        <div @click="tabClick('/Learn')">我的课程</div>
      </Col> -->
      <Col span="2" class="text-center help pointer relative" :class="$store.state.tab == '行业培训' ? 'active' : ''">
      <div>
        行业培训
        <Icon type="ios-arrow-down" />
        <div class="ivu-select-dropdown dropdown">
          <ul class="ivu-menu-drop-list">
            <li class="ivu-menu-item-group">
              <ul>
                <li class="ivu-menu-item" @click="tabClick('/IndustryTraining?subjectCode=1')">工程经理</li>
                <li class="ivu-menu-item" @click="tabClick('/IndustryTraining?subjectCode=2')">能力提高班</li>
                <li class="ivu-menu-item" @click="tabClick('/IndustryTraining?subjectCode=3')">运维工程师</li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
      </Col>
      <!-- 根据需求隐藏 -->
      <!-- <Col span="2" class="text-center pointer" :class="$store.state.tab == '选修课程' ? 'active' : ''">
        <div @click="tabClick('/Elective')">选修课程</div>
      </Col> -->
      <Col span="2" class="text-center pointer" :class="$store.state.tab == '测试' ? 'active' : ''">
      <div @click="tabClick('/Exam')">习题练习</div>
      </Col>
      <Col span="2" class="text-center pointer" :class="$store.state.tab == '在线考试' ? 'active' : ''">
      <div v-if="linkStatus == '0'" @click="tabClick('/Online')">在线考试</div>
      <a v-if="linkStatus == '1'" target="_blank" :href="examUrl" class="text-center pointer">在线考试</a>
      <!--<a v-if="linkStatus=='0'" target="_blank" :href="'https://www.kaoshixing.com/account/login/7362'" class="text-center pointer">在线考试</a>-->
      </Col>
      <!-- <Col span="2" class="text-center pointer" :class="$store.state.tab == '协会动态' ? 'active' : ''">
      <div @click="tabClick('/AssociationNews')"> 协会动态 </div>
      </Col>
      <Col span="2" class="text-center pointer" :class="$store.state.tab == '行业新闻' ? 'active' : ''">
      <div @click="tabClick('/Dynamic')"> 行业新闻 </div>
      </Col>
      <Col span="2" class="text-center pointer" :class="$store.state.tab == '行业法规' ? 'active' : ''">
      <div @click="tabClick('/Rule')"> 行业法规 </div>
      </Col> -->
      <!-- <Col span="2" class="text-center pointer" :class="$store.state.tab == '下载中心' ? 'active' : ''">
        <div @click="tabClick('/DownLoad')">下载中心</div>
      </Col> -->
      <!-- 移到更多 -->
      <!-- <Col span="2" class="text-center pointer" :class="$store.state.tab == '政策法规' ? 'active' : ''">
      <div @click="tabClick('/Policy')"> 政策法规 </div>
      </Col> -->
      <Col span="2" class="text-center pointer" :class="$store.state.tab == '通知公告' ? 'active' : ''">
      <div @click="tabClick('/Announcement')">通知公告</div>
      </Col>
      <!-- 根据需求隐藏 -->
      <!-- <Col span="2" class="text-center pointer" :class="$store.state.tab == '公示公告' ? 'active' : ''">
        <div @click="tabClick('/Information')">公示公告</div>
      </Col> -->
      <!-- 移到更多 -->
      <!-- <Col span="2" class="text-center pointer" :class="$store.state.tab == '下载中心' ? 'active' : ''">
        <div @click="tabClick('/DownLoad')">下载中心</div>
      </Col> -->
      <Col span="2" class="text-center help pointer relative"
        :class="{ 'active': $store.state.tab == '培训报名', 'dropdown-show': showTrainingDropdown }">
      <div>
        培训报名
        <Icon type="ios-arrow-down" />
        <div class="ivu-select-dropdown dropdown">
          <ul class="ivu-menu-drop-list">
            <li class="ivu-menu-item-group">
              <ul>

                <li class="ivu-menu-item" @click="tabClick('/onlineCourse?subjectCode=4')">职称继教</li>
                  <!-- <li class="ivu-menu-item" @click="openPrompt">职称继教</li> -->
                <!-- <li class="ivu-menu-item" @click="tabClick('/onlineCourse?subjectCode=5')">职称-继教中级</li>
                <li class="ivu-menu-item" @click="tabClick('/onlineCourse?subjectCode=6')">职称继教-副高级</li> -->
                <li class="ivu-menu-item" @click="tabClick('/Sign?subjectCode=1')">行业培训-工程经理</li>
                <li class="ivu-menu-item" @click="tabClick('/Sign?subjectCode=2')">行业培训-能力提高班</li>
                <li class="ivu-menu-item" @click="tabClick('/Sign?subjectCode=3')">行业培训-运维工程师</li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
      </Col>
      <Col span="2" class="text-center help pointer relative"
        :class="{ 'active': $store.state.tab == '操作指南', 'dropdown-show': showOperationDropdown }">
      <div>
        操作指南
        <Icon type="ios-arrow-down" />
        <div class="ivu-select-dropdown dropdown">
          <ul class="ivu-menu-drop-list">
            <li class="ivu-menu-item-group">
              <ul>
                <li class="ivu-menu-item" @click="tabClick('/Lecture?subjectCode=4')">职称继教</li>
                <!-- <li class="ivu-menu-item" @click="tabClick('/Lecture?subjectCode=5')">职称-继教中级</li>
                <li class="ivu-menu-item" @click="tabClick('/Lecture?subjectCode=6')">职称继教-副高级</li> -->
                <li class="ivu-menu-item" @click="tabClick('/Lecture?subjectCode=1')">行业培训-工程经理</li>
                <li class="ivu-menu-item" @click="tabClick('/Lecture?subjectCode=2')">行业培训-能力提高班</li>
                <li class="ivu-menu-item" @click="tabClick('/Lecture?subjectCode=3')">行业培训-运维工程师</li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
      </Col>
      <Col span="2" class="text-center help pointer relative" :class="$store.state.tab == '更多' ? 'active' : ''">
      <div>
        更多
        <Icon type="ios-arrow-down" />
        <div class="ivu-select-dropdown dropdown">
          <ul class="ivu-menu-drop-list">
            <li class="ivu-menu-item-group">
              <ul>
                <li class="ivu-menu-item" @click="tabClick('/Policy')">政策法规</li>
                <li class="ivu-menu-item" @click="tabClick('/DownLoad')">下载中心</li>
                <li class="ivu-menu-item" @click="tabClick('/Contact')">关于我们</li>
                <li class="ivu-menu-item" @click="tabClick('/Question')">常见答疑</li>
                <li class="ivu-menu-item" @click="tabClick('/Msg')">消息</li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
      </Col>
      <!-- <Col span="2" class="text-center pointer" :class="$store.state.tab == '在线转账' ? 'active' : ''">
      <div @click="tabClick('/Transfer')"> 在线转账 </div>
      </Col>-->
      <!-- 移到更多 -->
      <!-- <Col span="2" class="text-center pointer" :class="$store.state.tab == '关于我们' ? 'active' : ''">
        <div @click="tabClick('/Contact')">关于我们</div>
      </Col> -->
    </Row>
    <Login @loadtoken="initialization"></Login>
  </section>
</template>
<script>
import Login from "./Login";
import { MessageBox } from "element-ui";
import Logo from '@/assets/logo(3).png'
export default {
  name: "Header",
  data() {
    return {
      Logo: Logo,
      noread: false,
      linkStatus: "0",
      examUrl: "",
      logoUrl: [],
      showTitleDropdown: false, // 外部控制职称继教下拉
      showTrainingDropdown: false,  // 外部控制培训报名下拉
      showOperationDropdown: false,  // 外部操作指南继教下拉
      courseNameContent: [],// 行业培训的课程
    };
  },
  mounted() {
    this.onload();
  },
  methods: {
    openPrompt() {
      MessageBox.alert("本年度职称继教培训还未开始报名，敬请期待！", "提示", {
        confirmButtonText: "确定",
      });
    },
    tabClickZc(subjectCode) {

      console.log(this.$store.state.Login.login)
      var that = this;

      if (that.$cookie.get("xjaf-token")) {


        this.$http({
          url: that.webhost + "usersignup/checkSignup",
          method: "GET",

        }).then(({ data }) => {

          if (data && data.code === 0) {
            that.$router.push(`/onlineCourse?subjectCode=${subjectCode}`);

          } else {

            that.$router.push(`/IndustryTraining?subjectCode=${subjectCode}`);
          }
        });
      } else {

        that.$router.push(`/onlineCourse?subjectCode=${subjectCode}`);
      }
    },
    onload() {
      //初始化
      var that = this;
      this.getData();
      this.getLogoUrl();
      var token = that.$cookie.get("xjaf-token");
      var username = that.$cookie.get("xjaf-user");
      if (token != null && username != null) {
        this.checkToken(); //检查token
        this.messageNumber();
      }
      this.getCoursrList()
    },
    checkToken() {
      var that = this;
      var token = that.$cookie.get("xjaf-token");
      this.$http({
        url: that.webhost + "checkToken", //接受手机的接口
        method: "POST",
        data: token
      }).then(({ data }) => {
        // console.log(data, data.code);
        if (data.code === 0) {
        } else if (data.code === 1) {
          //清除cookies 重新登录
          this.$cookie.delete("xjaf-user");
          this.$cookie.delete("xjaf-token");
          MessageBox.alert(
            "系统检测到您已在其他地方登录，若要继续使用请重新登录！"
          ).then(action => {
            that.$router.go(0);
          });
        }
      });
    },
    getData() {
      var that = this;
      this.$http({
        url: that.webhost + "exam/getLinkStatus",
        method: "get"
      }).then(
        ({ data }) => {
          if (data && data.code === 0) {
            // console.log(data)
            if (data.data) {
              that.linkStatus = data.data.linkStatus;
              that.examUrl = data.data.examUrl;
            }
          } else {
            that.$message.error(data.msg);
          }
        },
        data => {
          console.log("获取失败"); // error callback
        }
      );
    },
    getLogoUrl() {
      var that = this;
      this.$http({
        url: that.webhost + "logo/picture",
        method: "get"
      }).then(
        ({ data }) => {
          if (data && data.code === 0) {
            console.log("logourl", data);
            if (data.data) {
              that.logoUrl = data.data.picture;
            }
            console.log(that.logoUrl);
          } else {
            that.$message.error(data.msg);
          }
        },
        data => {
          console.log("获取失败"); // error callback
        }
      );
    },
    loginClick() {
      this.$store.commit("login");
    },
    messageNumber() {
      var that = this;
      this.$http({
        url: that.webhost + "message/unread",
        method: "GET"
      }).then(({ data }) => {
        if (data && data.code === 0) {
          if (data.data > 0) {
            that.noread = true;
          }
        } else {
          that.$Message.error(data.msg);
        }
      });
    },
    initialization() {

      this.$emit("loadPage");
      this.messageNumber();
    },

    // 从外部控制下拉菜单显示的方法
    setGuideDropdown(show, type) {
      this.showOperationDropdown = false;
      this.showTitleDropdown = false;
      this.showTrainingDropdown = false;
      if (type == 1) {
        this.showTitleDropdown = show;
      } else if (type == 2) {
        this.showTrainingDropdown = show;
      } else if (type == 3) {
        this.showOperationDropdown = show;
      }

    },
    // 获取用户报名列表
    getCoursrList() {
      var that = this;
      this.$http({
        url: that.webhost + "guide/getAllSubject",
        method: "GET",
      }).then(({ data }) => {
        if (data && data.code === 0) {
          console.log(data.data)
          that.courseNameContent = data.data;
        }
      });
    }
  },
  components: {
    Login
  }
};
</script>
<style scoped>
.container {
  min-width: 1200px;
  font-family: "PingFang SC";
}

.titleM {
  margin: auto;
  margin-top: 4px;
  margin-bottom: 4px;
  width: 1200px;
}

.logo-wrapper {
  height: 114px;
  vertical-align: middle;
}

.logo-container {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.logo {
  height: 57px;
}

.Nav {
  height: 50px;
  line-height: 50px;
  background: #0078be;
  color: #ffffff;
  font-size: 18px;
  /*border-bottom: solid 1px #f1f1f1;*/
  width: 1200px;
  margin: auto;
  display: flex;
  justify-content: space-around;
  /*box-shadow: 0 1px 10px 3px rgba(0,0,0,.1);*/
  /*padding-bottom: 20px;*/
}

.Nav div {
  transition: 0.1s ease-in-out;
}

.Nav div:hover::after,
.Nav div:focus::after,
.Nav div.active::after {
  content: "";
  width: 60%;
  height: 3px;
  position: absolute;
  bottom: 0;
  left: 20%;
  background-color: #ffffff;
  /*box-shadow: 1px 1px 1px rgba(0,0,0,.39);*/
}

.Nav div.active {
  color: #ffffff;
}

.Nav div:hover,
.Nav div:focus {
  color: #ffffff;
}

.title {
  color: #005b9c;
  /*font-family: 'Microsoft YaHei';*/
  /*padding-left: 20px;*/
  display: table-cell;
  vertical-align: middle;
  height: 114px;
}

.title .wrapper {
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
  width: 100%;
  display: flex;
  align-items: center;
  gap: 20px;
}

.title .ZN {
  font-size: 25px;
  font-weight: bold;
}

.title .EN {
  font-size: 13px;
}

.brand .justify-line {
  width: 250px;
  text-align-last: justify;
  margin: 0;
}

.qualification {
  display: flex;
  align-items: center;
  gap: 20px;
}

.vertical-line {
  width: 2px;
  height: 40px;
  background-color: #7ca2c7;
}

.qualification .qualification-text {
  font-size: 18px;
  font-weight: bold;
  color: #434343;
}

.qualification .justify-line {
  width: 180px;
  text-align-last: justify;
  margin: 0;
}

.avatar {
  /*height: 40px;*/
  /*line-height: 40px;*/
  font-size: 16px;
  color: #333;
}

.avatar img {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border-color: #f1f1f1;
  box-shadow: 0 0 1px 2px rgba(222, 222, 222, 0.29);
}

.preImg {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border-color: #f1f1f1;
  background: #5b5b5b;
  box-shadow: 0 0 1px 2px rgba(222, 222, 222, 0.29);
  margin: auto;
}

.userM {
  height: 114px;
}

.userM .wrapper {
  position: absolute;
  top: 50%;
  transform: translate(0, -35%);
  width: 100%;
}

.status {
  margin-top: 5px;
}

.notice {
  padding-top: 4px;
  color: #333;
}

.notice img {
  width: 21px;
  height: 23px;
}

.alert {
  width: 7px;
  height: 7px;
  line-height: 12px;
  font-size: 12px;
  color: #fff;
  background-color: red;
  position: absolute;
  right: 36px;
  top: 1px;
  border-radius: 50%;
}

.NavFixed {
  position: fixed;
  top: 0;
  width: 100%;
  font-size: 18px;
  background-color: rgba(0, 0, 0, 0.79);
  color: #fff;
  z-index: 2;
  border-bottom: none;
}

/* 下拉框样式 */
.help i {
  transition: 0.2s ease-in-out;
}

.help:hover i {
  transform: rotate(180deg);
}

.help:hover .dropdown {
  display: block;
}

.help.dropdown-show .dropdown {
  display: block !important;
}

.help:hover .dropdown::after,
.help:focus .dropdown::after {
  content: none;
}

.ivu-select-dropdown {
  min-width: 100%;
  width: auto;
  max-height: none;
  display: none;
}

.ivu-select-dropdown {
  min-width: 147.797px;
  transform-origin: center top 0px;
  position: absolute;
  will-change: top, left;
  top: 40px;
  left: -1px;
}

.ivu-menu-item-group>ul {
  padding: 0 !important;
  list-style: none !important;
}

.ivu-select-dropdown .ivu-menu-item {
  margin: 0;
  line-height: normal;
  padding: 7px 12px;
  clear: both;
  color: #515a6e;
  font-size: 12px !important;
  white-space: nowrap;
  list-style: none;
  cursor: pointer;
  transition: background 0.2s ease-in-out;
}

.ivu-select-dropdown .ivu-menu-item {
  padding: 7px 12px 8px;
  font-size: 14px !important;
}

.ivu-menu-item:hover {
  color: #23b8ff;
}

@media only screen and (min-width: 1440px) {
  .Nav.NavFixed .ivu-select-dropdown {
    left: 16px;
  }
}

@media only screen and (min-width: 1920px) {
  .Nav.NavFixed .ivu-select-dropdown {
    left: 18%;
  }
}

.avatar img:after {
  border: none;
}

.idCard {
  font-size: 15px;
}

.else {
  font-size: 20px;
  line-height: 54px;
  padding-left: 5px;
}

.else:hover {
  color: #23b8ff;
}

.avatar .col-55 span:hover {
  color: #23b8ff;
}
</style>



// WEBPACK FOOTER //
// src/views/components/Header.vue